module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c083eb7d85a76d2d205dcf97a46f76ac.svg";